// Typelizer digest e537e35386885dadb2c5d797115b1626
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /learners/schools/:school_id/students/:student_id/preference_upgrade_request */
  learnersSchoolStudentPreferenceUpgradeRequest: (
    params: { schoolId: string | number; studentId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:student_id/preference_upgrade_request', params, options),
    method: 'post',
  }),

  /** POST /learners/students/:student_id/preference_upgrade_request */
  learnersStudentPreferenceUpgradeRequest: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/preference_upgrade_request', params, options),
    method: 'post',
  }),
}
